/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

define([
  "marionette",
  "modules/shared/sortableList/sortableListHeadSelector/template/sortableListHeadSelectorTemplate.html",
  "modules/shared/sortableList/sortableListHeadSelector/template/sortableListHeadSelectorItemTemplate.html",
], function (Marionette, SortableListHeadSelectorTemplate, SortableListHeadSelectorItemTemplate) {
  var SortableListHeadSelectorView = {};

  SortableListHeadSelectorView.sortableListHeadSelectorItemView = Marionette.ItemView.extend({
    template: SortableListHeadSelectorItemTemplate,
    tagName: "li",
    events: {
      "click input": function (e) {
        var selected = this.$el.find("input").prop("checked");
        this.trigger("toggle:column", selected);
        e.stopPropagation();
      },
      click: function (e) {
        e.stopPropagation();
      },
    },
  });

  SortableListHeadSelectorView.sortableListHeadSelectorView = Marionette.CompositeView.extend({
    template: SortableListHeadSelectorTemplate,
    itemView: SortableListHeadSelectorView.sortableListHeadSelectorItemView,
    itemViewContainer: "#headSelectorList",
  });

  return SortableListHeadSelectorView;
});
